import {
  CREATE_STORYBOARD_REQUEST, CREATING_STORYBOARD_SUCCEEDED, CREATING_STORYBOARD_FAILED,
  UPDATE_STORYBOARD_REQUEST, UPDATING_STORYBOARD_SUCCEEDED, UPDATING_STORYBOARD_FAILED,
  FETCH_STORYBOARDS_REQUEST, FETCHING_STORYBOARDS_SUCCEEDED, FETCHING_STORYBOARDS_FAILED,
  FETCH_STORYBOARD_REQUEST, FETCHING_STORYBOARD_SUCCEEDED, FETCHING_STORYBOARD_FAILED,
  DELETE_STORYBOARD_REQUEST, DELETING_STORYBOARD_SUCCEEDED, DELETING_STORYBOARD_FAILED,
  CLONE_STORYBOARD_REQUEST, CLONING_STORYBOARD_SUCCEEDED, CLONING_STORYBOARD_FAILED,
  FETCH_STORYBOARD_USERS, FETCHING_STORYBOARD_USERS_SUCCEEDED, FETCHING_STORYBOARD_USERS_FAILED,
  ADD_USERS_TO_STORYBOARD, ADD_USERS_TO_STORYBOARD_SUCCEEDED, ADD_USERS_TO_STORYBOARD_FAILED,
  UPDATE_STORYBOARD_USER_ACCESS, UPDATE_STORYBOARD_USER_ACCESS_SUCCEEDED, UPDATE_STORYBOARD_USER_ACCESS_FAILED,
  REMOVE_USER_FROM_STORYBOARD, REMOVE_USER_FROM_STORYBOARD_SUCCEEDED, REMOVE_USER_FROM_STORYBOARD_FAILED,
  SET_STORYBOARD_USER_ROLE, INVALIDATE_STORYBOARD_STATE, UPDATE_APPEARANCE_REQUEST,
  UNPUBLISH_PAGE_REQUEST, UNPUBLISHING_PAGE_SUCCEEDED, UNPUBLISHING_PAGE_FAILED, INVALIDATE_UNPUBLISH_PAGE, INVALIDATE_STORYBOARDS_STATE,
  MAKE_HOME_PAGE_FOR_STORYBOARD, MAKE_HOME_PAGE_FOR_STORYBOARD_SUCCEEDED, MAKE_HOME_PAGE_FOR_STORYBOARD_FAILED,
  FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD, FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD_SUCCEEDED, FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD_FAILED,
  FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD, FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD_SUCCEEDED, FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD_FAILED,

  CREATE_GATING_CONFIG_REQUEST, UPDATE_GATING_CONFIG_REQUEST, DELETE_GATING_CONFIG_REQUEST, RESET_GATING_CONFIG_REQUEST,

  INITIATE_PPT_UPLOAD_FOR_STORYBOARD, UPDATE_PPT_UPLOAD_FOR_STORYBOARD_PROGRESS,
  CREATE_STORYBOARD_FROM_PPT_REQUEST, CREATING_STORYBOARD_FROM_PPT_SUCCEEDED, CREATING_STORYBOARD_FROM_PPT_FAILED, 
  CREATE_STORYBOARD_FROM_FIGMA_REQUEST, CREATING_STORYBOARD_FROM_FIGMA_SUCCEEDED, CREATING_STORYBOARD_FROM_FIGMA_FAILED,
  FETCH_DOMAINS_REQUEST, FETCHING_DOMAINS_SUCCEEDED, FETCHING_DOMAINS_FAILED,
  FETCH_PAGE_PERFORMANCE_METRICS_REQUEST, FETCHING_PAGE_PERFORMANCE_METRICS_SUCCEEDED, FETCHING_PAGE_PERFORMANCE_METRICS_FAILED,
  FETCH_PAGE_PERFORMANCE_HISTORY_REQUEST, FETCHING_PAGE_PERFORMANCE_HISTORY_SUCCEEDED, FETCHING_PAGE_PERFORMANCE_HISTORY_FAILED, INVALIDATE_PAGE_PERFORMANCE, UPDATE_HOME_PAGE_FOR_STORYBAORD, INVALIDATE_STORYBOARD_PAGES, TRIGGER_PAGE_PROCESSING_FOR_STORYBOARD,
  UPDATE_STORYBOARD_ITEM,
  UPDATE_GATING_CONFIGS_PROPERTIES,
  STORYBOARD_LEVEL_SEEK_INDEX_FAILED,
  STORYBOARD_LEVEL_SEEK_INDEX_SUCCEEDED,
  STORYBOARD_LEVEL_SEEK_INDEX_REQUEST, 
} from 'constants/actionTypes';

import { call, put, takeEvery, select } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';
import _ from 'lodash';
import { createMixpanelEvent } from './mixpanel';

import { MIXPANEL_CREATE_STORYBOARD, MIXPANEL_CLONE_STORYBOARD, MIXPANEL_STORYBOARD_IMPORTED } from 'constants/mixpanelEvents';
import { getStoryboardMixpanelEventPayload } from 'services/mixpanelUtil';

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const STORYBOARD_URL = `${apiUrl}/api/2.0/storyboards`;
const PAGE_URL = `${apiUrl}/api/2.0/pages`;
const WIDGET_URL = `${apiUrl}/api/1.0/widgets`;
const FIGMA_BASE_URL = `${apiUrl}/api/1.0/integrations/figma`;
const WORKSPACE_URL = `${apiUrl}/api/2.0/workspaces`;
const STORYBOARD_LEVEL_SEEK_INDEX_URL = `${apiUrl}/api/2.0/cleverstory/seek/index/storyboard`;

/**
 * Create storyboard for user
*/
export const createStoryboard = createAction(CREATE_STORYBOARD_REQUEST, (request, callback) => {
  return {
    request: request,
    callback: callback
  };
})

export const createStoryboardSucceeded = createAction(CREATING_STORYBOARD_SUCCEEDED, (response) => {
  return response;
})

export const createStoryboardFailed = createAction(CREATING_STORYBOARD_FAILED, (error) => {
  return error;
})

function* createStoryboardSaga(action) {
  const { request, callback } = action.payload;

  const createStoryboardAPI = () => {
    return axios.post(STORYBOARD_URL, request).then(response => response.data);
  }

  try {
    const response = yield call(createStoryboardAPI);
    if (response) {
      yield put(createStoryboardSucceeded(response));

      const mixPanelPayload = getStoryboardMixpanelEventPayload(_.get(response, 'id', ""), _.get(response, 'name', ""), _.get(response, 'type', ""))
  
      yield put(createMixpanelEvent(MIXPANEL_CREATE_STORYBOARD, mixPanelPayload))

      if (callback) {
        callback(response);
      }
    }
  } catch (error) {
    yield put(createStoryboardFailed(error));
  }
}

/**
 * Update storyboard for user
*/
export const updateStoryboard = createAction(UPDATE_STORYBOARD_REQUEST, (id, request, callback) => {
  return {
    id: id,
    request: request,
    callback: callback
  }
})

export const updateStoryboardSucceeded = createAction(UPDATING_STORYBOARD_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
})

export const updateStoryboardFailed = createAction(UPDATING_STORYBOARD_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

export const updateStoryboardItem = createAction(UPDATE_STORYBOARD_ITEM, (request) => request)

function* updateStoryboardSaga(action) {
  const { id, request, callback } = action.payload;

  let url = buildUrl(STORYBOARD_URL, {
    path: `/${id}`
  });

  const gatingConfigurations =  yield select(state => {
    return _.get(state, `storyboards.storyboard.item.gatingConfigurations`, []);
  });

  var storyboardRequest = _.cloneDeep(request);

  if(gatingConfigurations.length > 0) {
    storyboardRequest = {
      ...storyboardRequest,
      gatingConfigurations: gatingConfigurations.map(item => {
        return {
          ...item,
          gating: _.get(item, 'gating.id', null),
          page: _.get(item, 'page.id', null),
          target: item.target ? { 
            id: _.get(item, 'target.id', null), 
            type:  _.get(item, 'target.entityType', null) || _.get(item, 'target.type', null)
          } : null
        }
      })
    }
  }

  if (gatingConfigurations.length == 0) {
    storyboardRequest = {
      ...storyboardRequest,
      gatingConfigurations: []
    }
  }

  const appearance = yield select(state => {
    return _.get(state, `storyboards.storyboard.item.appearance`, null);
  });

  if (appearance) {
    var appearanceBackground = _.get(appearance, 'background');
    var slideBackground = _.get(appearance, 'slideBackground');

    const updatedAppearance = {
        ...appearance,
        background: {
            ...appearance.background,
            media: _.get(appearanceBackground, 'media') ? _.get(appearanceBackground, 'media.id') : null
        },
        slideBackground: {
            ...slideBackground,
            media: _.get(slideBackground, 'media') ? _.get(slideBackground, 'media.id') : null
        }
    };

    storyboardRequest = {
        ...storyboardRequest,
        appearance: updatedAppearance
    };
  }

  const updateStoryboardAPI = () => {
    return axios.put(url, storyboardRequest).then(response => response.data);
  }

  try {
    const response = yield call(updateStoryboardAPI);
    if (response) {
      yield put(updateStoryboardSucceeded(id, response));

      if (callback) {
        callback();
      }
    }
  } catch (error) {
    yield put(updateStoryboardFailed(id, error));
  }
}

/**
 * Fetch storyboards for user
*/
export const fetchStoryboards = createAction(FETCH_STORYBOARDS_REQUEST, (request) => {
  return request;
});

const fetchingStoryboardsSucceeded = createAction(FETCHING_STORYBOARDS_SUCCEEDED, (request, response) => {
  return {
    request: request,
    response: response
  };
});

const fetchingStoryboardsFailed = createAction(FETCHING_STORYBOARDS_FAILED, (request, error) => {
  return {
    request: request,
    error: error
  };
});

function* fetchStoryboardsSaga(action) {
  const request = action.payload;

  const fetchStoryboardsAPI = () => {
    return axios.post(`${STORYBOARD_URL}/search`, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchStoryboardsAPI);
    yield put(fetchingStoryboardsSucceeded(request, response));
  } catch (error) {
    yield put(fetchingStoryboardsFailed(request, error));
  }
}

/**
 * Fetch storyboard for user
*/
export const fetchStoryboard = createAction(FETCH_STORYBOARD_REQUEST);

const fetchingStoryboardSucceeded = createAction(FETCHING_STORYBOARD_SUCCEEDED, (response) => {
  return response;
});

const fetchingStoryboardFailed = createAction(FETCHING_STORYBOARD_FAILED, (error) => {
  return error;
});

function* fetchStoryboardSaga(action) {
  const id = action.payload;

  const fetchStoryboardAPI = () => {
    return axios.get(`${STORYBOARD_URL}/${id}`).then(response => response.data);
  }

  try {
    const response = yield call(fetchStoryboardAPI);
    yield put(fetchingStoryboardSucceeded(response));
  } catch (error) {
    yield put(fetchingStoryboardFailed(error));
  }
}

/**
 * Delete storyboard 
*/
export const deleteStoryboard = createAction(DELETE_STORYBOARD_REQUEST, (id) => {
  return id;
})

export const deleteStoryboardSucceeded = createAction(DELETING_STORYBOARD_SUCCEEDED, (id) => {
  return id;
})

export const deleteStoryboardFailed = createAction(DELETING_STORYBOARD_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* deleteStoryboardSaga(action) {
  const id = action.payload;

  let url = buildUrl(STORYBOARD_URL, {
    path: id
  });

  const deleteStoryboardAPI = () => {
    return axios.delete(url).then(response => response.data);
  }

  try {
    yield call(deleteStoryboardAPI);
    yield put(deleteStoryboardSucceeded(id));
  } catch (error) {
    yield put(deleteStoryboardFailed(id, error));
  }
}

/**
 * Clone storyboard
*/
export const cloneStoryboard = createAction(CLONE_STORYBOARD_REQUEST, (id, list, name) => {
  return {
    id: id,
    list: list,
    name: name
  };
})

export const cloningStoryboardSucceeded = createAction(CLONING_STORYBOARD_SUCCEEDED, (response) => {
  return response;
})

export const cloningStoryboardFailed = createAction(CLONING_STORYBOARD_FAILED, (error) => {
  return error;
})

function* cloneStoryboardSaga(action) {
  const { id, list, name } = action.payload;

  const params = {
    list: list,
    name: name
  };

  let url = buildUrl(STORYBOARD_URL, {
    path: `${id}/clone`,
    queryParams: params
  });

  const cloneStoryboardAPI = () => {
    return axios.post(url).then(response => response.data);
  }

  try {
    const response = yield call(cloneStoryboardAPI);
    if (response) {
      yield put(cloningStoryboardSucceeded(response));

      const mixPanelPayload = getStoryboardMixpanelEventPayload(_.get(response, 'id', ""), _.get(response, 'name', ""), _.get(response, 'type', ""))
  
      yield put(createMixpanelEvent(MIXPANEL_CLONE_STORYBOARD, mixPanelPayload))
    }

  } catch (error) {
    yield put(cloningStoryboardFailed(error));
  }
}

/**
 * Fetch users for storyboard
*/
export const fetchStoryboardUsers = createAction(FETCH_STORYBOARD_USERS, (id, request) => {
  return {
    id: id,
    request: request
  }
})

const fetchStoryboardUsersSucceeded = createAction(FETCHING_STORYBOARD_USERS_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  };
})

const fetchStoryboardUsersFailed = createAction(FETCHING_STORYBOARD_USERS_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* fetchStoryboardUsersSaga(action) {
  const { id, request } = action.payload;

  let url = buildUrl(STORYBOARD_URL, {
    path: `${id}/users/search`
  });

  const fetchStoryboardUsersAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchStoryboardUsersAPI);
    yield put(fetchStoryboardUsersSucceeded(id, response));
  } catch (error) {
    yield put(fetchStoryboardUsersFailed(id, error));
  }
}

/**
 * Add users to storyboard
*/
export const addUsersToStoryboard = createAction(ADD_USERS_TO_STORYBOARD, (id, request, callback) => {
  return {
    id: id,
    request: request,
    callback: callback
  }
})

const addUsersToStorybordSucceeded = createAction(ADD_USERS_TO_STORYBOARD_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
})

const addUsersToStoryboardFailed = createAction(ADD_USERS_TO_STORYBOARD_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* addUsersToStoryboardSaga(action) {
  const { id, request, callback } = action.payload;

  let url = buildUrl(STORYBOARD_URL, {
    path: `${id}/users`
  });

  const addUsersToStoryboardAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(addUsersToStoryboardAPI);
    yield put(addUsersToStorybordSucceeded(id, response));

    if (callback) {
      callback(response);
    }
  } catch (error) {
    yield put(addUsersToStoryboardFailed(id, error));
  }
}

/**
 * update Storyboard user access
*/
export const updateStoryboardUserAccess = createAction(UPDATE_STORYBOARD_USER_ACCESS, (id, request, callback) => {
  return {
    id: id,
    request: request,
    callback: callback
  }
})

const updateStoryboardUserAccessSucceeded = createAction(UPDATE_STORYBOARD_USER_ACCESS_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
})

const updateStoryboardUserAccessFailed = createAction(UPDATE_STORYBOARD_USER_ACCESS_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* updateStoryboardUserAccessSaga(action) {
  const { id, request, callback } = action.payload;

  let url = buildUrl(STORYBOARD_URL, {
    path: `user-access/${id}`
  });

  const updateStoryboardUserAccessAPI = () => {
    return axios.put(url, request).then(response => response.data);
  }

  try {
    const response = yield call(updateStoryboardUserAccessAPI);
    yield put(updateStoryboardUserAccessSucceeded(id, response));
    if (callback) {
      callback(response);
    }
  } catch (error) {
    yield put(updateStoryboardUserAccessFailed(id, error));
  }
}

/**
 * Remove user from storyboard
*/
export const removeUserFromStoryboard = createAction(REMOVE_USER_FROM_STORYBOARD, (id, callback) => {
  return {
    id: id,
    callback: callback
  };
})

const removeUserFromStoryboardSucceeded = createAction(REMOVE_USER_FROM_STORYBOARD_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
})

const removeUserFromStoryboardFailed = createAction(REMOVE_USER_FROM_STORYBOARD_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* removeUserFromStoryboardSaga(action) {
  const { id, callback } = action.payload;

  let url = buildUrl(STORYBOARD_URL, {
    path: `user-access/${id}`
  });

  const removeUserFromStoryboardAPI = () => {
    return axios.delete(url).then(response => response.data);
  }

  try {
    const response = yield call(removeUserFromStoryboardAPI);
    yield put(removeUserFromStoryboardSucceeded(id, response));
    if (callback) {
      callback(response);
    }
  } catch (error) {
    yield put(removeUserFromStoryboardFailed(id, error));
  }
}

/**
 * Update storyboard user role
*/
export const setStoryboardUserRole = createAction(SET_STORYBOARD_USER_ROLE, (userId, role) => {
  return {
    userId: userId,
    role: role
  }
})



/**
 * Make Page as Home Page from storyboard
*/
export const makeHomePageForStoryboard = createAction(MAKE_HOME_PAGE_FOR_STORYBOARD, (id, page) => {
  return {
    id: id,
    page: page
  };
})

const makeHomePageForStoryboardSucceeded = createAction(MAKE_HOME_PAGE_FOR_STORYBOARD_SUCCEEDED, (id, page, response) => {
  return {
    id: id,
    page: page,
    response: response
  };
})

const makeHomePageForStoryboardFailed = createAction(MAKE_HOME_PAGE_FOR_STORYBOARD_FAILED, (id, page, error) => {
  return {
    id: id,
    page: page,
    error: error
  };
})

function* makeHomePageForStoryboardSaga(action) {
  const { id, page, callback } = action.payload;

  const params = {
    page: page
  }

  let url = buildUrl(STORYBOARD_URL, {
    path: `${id}/home`,
    queryParams: params
  });

  const makeHomePageForStoryboardAPI = () => {
    return axios.post(url).then(response => response.data);
  }

  try {
    const response = yield call(makeHomePageForStoryboardAPI);
    yield put(makeHomePageForStoryboardSucceeded(id, page, response));
    if (callback) {
      callback(response);
    }
  } catch (error) {
    yield put(makeHomePageForStoryboardFailed(id, error));
  }
}

/**
 * Update interactive appearance
*/
export const updateAppearance = createAction(UPDATE_APPEARANCE_REQUEST, (storyboard, request) => {
  return {
    id: storyboard,
    appearance: request
  }
})

/**
 * Create Gating Config
*/
export const createGatingConfig = createAction(CREATE_GATING_CONFIG_REQUEST, (request) => {
  return request;
})

/**
 * Update Gating Config
*/
export const updateGatingConfig = createAction(UPDATE_GATING_CONFIG_REQUEST, (id, request) => {
  return {
    id: id,
    request: request
  };
})

/**
 * Delete Gating Config
*/
export const deleteGatingConfig = createAction(DELETE_GATING_CONFIG_REQUEST, (id) => {
  return {
    id : id
  };
})

/**
 * Create Gating Config
*/
export const resetGatingConfig = createAction(RESET_GATING_CONFIG_REQUEST, (gatingConfigs) => {
  return {
    gatingConfigs
  };
})

/**
 * Unpublish page
*/
export const unPublishPage = createAction(UNPUBLISH_PAGE_REQUEST, (id) => {
  return {
    id: id
  }
})

const unPublishPageSucceeded = createAction(UNPUBLISHING_PAGE_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
})

const unPublishPageFailed = createAction(UNPUBLISHING_PAGE_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* unPublishPageSaga(action) {
  const { id, callback } = action.payload;

  let url = buildUrl(PAGE_URL, {
    path: `${id}/unpublish`
  });

  const unPublishPageAPI = () => {
    return axios({
      method: 'POST',
      url: url,
    }).then(response => response.data);
  }

  try {
    const response = yield call(unPublishPageAPI);
    yield put(unPublishPageSucceeded(id, response));
    if (callback) yield call(callback, response);
  } catch (error) {
    yield put(unPublishPageFailed(id, error));
  }
}

/**
 * Fetch Gating Configs 
*/

export const updateGatingConfigurations = createAction(UPDATE_GATING_CONFIGS_PROPERTIES, (response) => {
  return {
    response
  };
});

export const invalidateStoryboardState = createAction(INVALIDATE_STORYBOARD_STATE);
export const invalidateStoryboardsState = createAction(INVALIDATE_STORYBOARDS_STATE);
export const invalidateUnpublishPage = createAction(INVALIDATE_UNPUBLISH_PAGE);


/**
 * Fetch pages for landing page
*/
export const fetchAllPagesForLandingStoryboard = createAction(FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD, (request) => {
  return request;
});

const fetchingAllPagesForLandingStoryboardSuccedded = createAction(FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD_SUCCEEDED, (response, storyboard) => {
  return {
    storyboard: storyboard,
    response: response
  }
});

const fetchingAllPagesForLandingStoryboardFailed = createAction(FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD_FAILED, (error, storyboard) => {
  return {
    error: error,
    storyboard: storyboard
  };
});

function* fetchAllPagesForLandingStoryboardSaga(action) {
  const request = action.payload;

  const fetchPagesForStoryboardAPI = () => {
    return axios.post(`${PAGE_URL}/search`, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchPagesForStoryboardAPI);
    yield put(fetchingAllPagesForLandingStoryboardSuccedded(response, request.storyboard));
  } catch (error) {
    yield put(fetchingAllPagesForLandingStoryboardFailed(error, request.storyboard));
  }
}

/**
 * Update home page for storyboard
*/
export const updateHomePageForStoryboard = createAction(UPDATE_HOME_PAGE_FOR_STORYBAORD, (response) => {
  return response;
})


/**
 * Fetch pages for interactive page
*/
export const fetchAllPagesForInteractiveStoryboard = createAction(FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD, (request) => {
  return request;
});

const fetchingAllPagesForInteractiveStoryboardSuccedded = createAction(FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD_SUCCEEDED, (response, request) => {
  return {
    request: request,
    response: response
  }
});

const fetchingAllPagesForInteractiveStoryboardFailed = createAction(FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD_FAILED, (error, request) => {
  return {
    error: error,
    request: request
  };
});

function* fetchAllPagesForInteractiveStoryboardSaga(action) {
  const request = action.payload;

  let url = buildUrl(WIDGET_URL, {
    path: `/interactive/pages`,
    queryParams: request
  });

  const fetchPagesForInteractiveStoryboardAPI = () => {
    return axios.post(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchPagesForInteractiveStoryboardAPI);
    yield put(fetchingAllPagesForInteractiveStoryboardSuccedded(response, request));
  } catch (error) {
    yield put(fetchingAllPagesForInteractiveStoryboardFailed(error, request));
  }
}

/**
 * Initiate PPT upload 
*/
export const initiatePPTUpload = createAction(INITIATE_PPT_UPLOAD_FOR_STORYBOARD, (request) => {
  return request;
})

export const updatePPTUploadProgress = createAction(UPDATE_PPT_UPLOAD_FOR_STORYBOARD_PROGRESS, (id, progress) => {
  return {
    id: id,
    progress: progress
  }
})

export const createStoryboardFromPPT = createAction(CREATE_STORYBOARD_FROM_PPT_REQUEST, (id, request) => {
  return {
    id: id,
    request: request
  }
})

const createStoryboardFromPPTSucceeded = createAction(CREATING_STORYBOARD_FROM_PPT_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
})

const createStoryboardFromPPTFailed = createAction(CREATING_STORYBOARD_FROM_PPT_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* createStoryboardFromPPTSaga(action) {
  const { id, request } = action.payload;

  let url = buildUrl(STORYBOARD_URL, {
    path: `/ppt`
  });

  const createStoryboardFromPPTAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(createStoryboardFromPPTAPI);
    if (response) {
      const { name } = response.storyboard;
      const storyboardId = response.storyboard?.id;
      const storyboardType = response.storyboardType;
      const mixpanelPayload = getStoryboardMixpanelEventPayload(storyboardId, name, storyboardType);

      yield put(createMixpanelEvent(MIXPANEL_STORYBOARD_IMPORTED, { ...mixpanelPayload, importing_format: "PPT" }));
      yield put(createStoryboardFromPPTSucceeded(id, response));
    }
  } catch (error) {
    yield put(createStoryboardFromPPTFailed(id, error));
  }
}

/*
* Create Storyboard from Figma
*/
export const createStoryboardFromFigma = createAction(CREATE_STORYBOARD_FROM_FIGMA_REQUEST, (id, request, workspace) => {
  return {
    id: id,
    request: request,
    workspace: workspace
  };
})

export const createStoryboardFromFigmaSucceeded = createAction(CREATING_STORYBOARD_FROM_FIGMA_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response,
  };
})

export const createStoryboardFromFigmaFailed = createAction(CREATING_STORYBOARD_FROM_FIGMA_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  };
})

function* createStoryboardFromFigmaSaga(action) {

  const { id, request, workspace } = action.payload;

  let url = buildUrl(`${FIGMA_BASE_URL}/import`, {
  });

  const importFigmaAPI = () => {
    return axios.post(url, request, {
      headers: {
        'CS-WORKSPACE-ID': workspace
      }}).then(response => response.data);
  }

  try {
    const response = yield call(importFigmaAPI);
    if (response) {
      const { name } = response.storyboard;
      const storyboardId = response.storyboard?.id;
      const storyboardType = response.storyboardType;
      const mixpanelPayload = getStoryboardMixpanelEventPayload(storyboardId, name, storyboardType);

      yield put(createStoryboardFromFigmaSucceeded(id, response));
      yield put(createMixpanelEvent(MIXPANEL_STORYBOARD_IMPORTED, { ...mixpanelPayload, importing_format: "Figma" }));
    }

  } catch (error) {
    yield put(createStoryboardFromFigmaFailed(id, error));
  }
}

/**
 * Fetch Domains for site url setting
*/
export const fetchDomains = createAction(FETCH_DOMAINS_REQUEST, (request) => {
  return request;
 }
);

const fetchingDomainsSucceeded = createAction(FETCHING_DOMAINS_SUCCEEDED, (response, request) => {
  return {
    request: request,
    response: response,
    };
  }
);

const fetchingDomainsFailed = createAction(FETCHING_DOMAINS_FAILED, (error, request) => {
  return {
    error: error,
    request: request,
    };
  }
);

function* fetchDomainsSaga(action) {
  const request = action.payload;

  let url = buildUrl(WORKSPACE_URL, {
    path: `/domains`,
  });

  const fetchDomainsAPI = () => {
    return axios.get(url).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDomainsAPI);
    yield put(
      fetchingDomainsSucceeded(response, request)
    );
  } catch (error) {
    yield put(fetchingDomainsFailed(error, request));
  }
}

/**
 * Invalidate all pages in the storyboard
*/
export const invalidateStoryboardPages = createAction(INVALIDATE_STORYBOARD_PAGES, (storyboardId) => {
  return storyboardId;
});

function* invalidateStoryboardPagesSaga(action) {
  const request = action.payload;

  let url = buildUrl(STORYBOARD_URL, {
    path: `${request}/invalidate/aws`,
  });

  const invalidateStoryboardPagesAPI = () => {
    return axios.get(url).then((response) => response.data);
  };

  try {
    yield call(invalidateStoryboardPagesAPI);
  } catch { 
    console.log("error in storyboard pages invalidation")
  }
}

/**
 * Trigger page processing for storyboard
*/
export const triggerPageProcessingForStoryboard = createAction(TRIGGER_PAGE_PROCESSING_FOR_STORYBOARD, (storyboardId) => {
  return storyboardId;
});

function* triggerPageProcessingForStoryboardSaga(action) {
  const request = action.payload;

  let url = buildUrl(STORYBOARD_URL, {
    path: `${request}/processing`,
  });

  const triggerPageProcessingForStoryboardAPI = () => {
    return axios.get(url).then((response) => response.data);
  };

  try {
    yield call(triggerPageProcessingForStoryboardAPI);
  } catch { 
    console.log("error in trigger page processing")
  }
}

/**
 * Fetch Site Performance Metrics
*/
export const fetchPagePerformanceMetrics = createAction(FETCH_PAGE_PERFORMANCE_METRICS_REQUEST, (pageId, test) => {
  return {
    pageId: pageId,
    test: test
 }
});

const fetchingPagePerformanceMetricsSucceeded = createAction(FETCHING_PAGE_PERFORMANCE_METRICS_SUCCEEDED, (response) => {
  return {
    response: response
    };
  }
);

const fetchingPagePerformanceMetricsFailed = createAction(FETCHING_PAGE_PERFORMANCE_METRICS_FAILED, (error) => {
  return {
    error: error
    };
  }
);

function* fetchPagePerformanceMetricsSaga(action) {
  const { pageId, test} = action.payload;

  let url = buildUrl(STORYBOARD_URL, {
    path: `/${pageId}/performance`,
    queryParams: {test: test}
  });

  const fetchPagePerformanceMetricsAPI = () => {
    return axios.get(url).then(response => response.data);
  };

  try {
    const response = yield call(fetchPagePerformanceMetricsAPI);
    if (response) {
      yield put(fetchingPagePerformanceMetricsSucceeded(response));
    }
  } catch (error) {
    yield put(fetchingPagePerformanceMetricsFailed(error));
  }
}

/**
 * Fetch Site Performance History
*/
export const fetchPagePerformanceHistory = createAction(FETCH_PAGE_PERFORMANCE_HISTORY_REQUEST, (pageId) => {
  return {
    pageId: pageId
 }
});

const fetchingPagePerformanceHistorySucceeded = createAction(FETCHING_PAGE_PERFORMANCE_HISTORY_SUCCEEDED, (response) => {
  return {
      response: response
    };
  }
);

const fetchingPagePerformanceHistoryFailed = createAction(FETCHING_PAGE_PERFORMANCE_HISTORY_FAILED, (error) => {
  return {
      error: error
    };
  }
);

function* fetchPagePerformanceHistorySaga(action) {
  const { pageId } = action.payload;

  let url = buildUrl(STORYBOARD_URL, {
    path: `/${pageId}/performance/history`
  });

  const fetchPagePerformanceHistoryAPI = () => {
    return axios.get(url).then(response => response.data);
  };

  try {
    const response = yield call(fetchPagePerformanceHistoryAPI);
    if (response) {
      yield put(fetchingPagePerformanceHistorySucceeded(response));
    }
  } catch (error) {
    yield put(fetchingPagePerformanceHistoryFailed(error));
  }
}

/**
 * Invalidate Page Performance
*/
export const invalidatePagePerformance = createAction(INVALIDATE_PAGE_PERFORMANCE);

/**
 * Storyboard Level Seek Indexing
*/

export const storyboardLevelSeekIndex = createAction(STORYBOARD_LEVEL_SEEK_INDEX_REQUEST, (id, request) => {
  return {
    id: id,
    request: request
  }
});

export const storyboardLevelSeekIndexSucceeded = createAction(STORYBOARD_LEVEL_SEEK_INDEX_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

export const storyboardLevelSeekIndexFailed = createAction(STORYBOARD_LEVEL_SEEK_INDEX_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
});

function* storyboardLevelSeekIndexSaga(action) {
  const {id, request } = action.payload;
 
  const storyboardSeekIndexingAPI = () => {
    return axios.post(STORYBOARD_LEVEL_SEEK_INDEX_URL, request).then(response => response.data);
  }

  try {
    const response = yield call(storyboardSeekIndexingAPI);
    if (response) {
      yield put(storyboardLevelSeekIndexSucceeded(id, response));
    }
  } catch (error) {
    yield put(storyboardLevelSeekIndexFailed(id, error));
  }
}

export default function* storyboardSaga() {
  yield takeEvery(CREATE_STORYBOARD_REQUEST, createStoryboardSaga);
  yield takeEvery(UPDATE_STORYBOARD_REQUEST, updateStoryboardSaga);
  yield takeEvery(FETCH_STORYBOARDS_REQUEST, fetchStoryboardsSaga);
  yield takeEvery(FETCH_STORYBOARD_REQUEST, fetchStoryboardSaga);
  yield takeEvery(DELETE_STORYBOARD_REQUEST, deleteStoryboardSaga);
  yield takeEvery(CLONE_STORYBOARD_REQUEST, cloneStoryboardSaga);
  yield takeEvery(FETCH_STORYBOARD_USERS, fetchStoryboardUsersSaga);
  yield takeEvery(ADD_USERS_TO_STORYBOARD, addUsersToStoryboardSaga);
  yield takeEvery(UPDATE_STORYBOARD_USER_ACCESS, updateStoryboardUserAccessSaga);
  yield takeEvery(REMOVE_USER_FROM_STORYBOARD, removeUserFromStoryboardSaga);
  yield takeEvery(UNPUBLISH_PAGE_REQUEST, unPublishPageSaga);
  yield takeEvery(MAKE_HOME_PAGE_FOR_STORYBOARD, makeHomePageForStoryboardSaga);
  yield takeEvery(FETCHING_ALL_PAGES_FOR_LANDING_STORYBOARD, fetchAllPagesForLandingStoryboardSaga);
  yield takeEvery(FETCHING_ALL_PAGES_FOR_INTERACTIVE_STORYBOARD, fetchAllPagesForInteractiveStoryboardSaga);
  yield takeEvery(CREATE_STORYBOARD_FROM_PPT_REQUEST, createStoryboardFromPPTSaga);
  yield takeEvery(CREATE_STORYBOARD_FROM_FIGMA_REQUEST, createStoryboardFromFigmaSaga);
  yield takeEvery(FETCH_DOMAINS_REQUEST, fetchDomainsSaga);
  yield takeEvery(INVALIDATE_STORYBOARD_PAGES, invalidateStoryboardPagesSaga);
  yield takeEvery(TRIGGER_PAGE_PROCESSING_FOR_STORYBOARD, triggerPageProcessingForStoryboardSaga);
  yield takeEvery(FETCH_PAGE_PERFORMANCE_METRICS_REQUEST, fetchPagePerformanceMetricsSaga);
  yield takeEvery(FETCH_PAGE_PERFORMANCE_HISTORY_REQUEST, fetchPagePerformanceHistorySaga);
  yield takeEvery(STORYBOARD_LEVEL_SEEK_INDEX_REQUEST, storyboardLevelSeekIndexSaga);
}